import React from 'react';

export function PortfolioListItem({ item, isLast }) {
  return (
    <div className={`item ${isLast ? '' : 'mb-80'}`}>
      <div className="img">
        <a href={`/portfolio-details/${item.id}`}>
          <img src={item.coverImg || '/assets/imgs/works/1/1.jpg'} alt={item.title} />
        </a>
      </div>
      <div className="content">
        <div className="d-flex align-items-center mb-15">
          {item.category && (
            <div className="post-date">{item.category}</div>
          )}
        </div>
        <h3 className="mb-15">
          <a href={`/portfolio-details/${item.id}`}>
            {item.title}{' '}
            {item.titleHighlight && (
              <span className="fw-200">{item.titleHighlight}</span>
            )}
          </a>
        </h3>
        <p>{item.excerpt}</p>
        <div className="d-flex align-items-center flex-wrap mt-40" style={{ gap: '24px' }}>
          <a
            href={`/portfolio-details/${item.id}`}
            className="d-flex align-items-center main-color"
          >
            <span className="text mr-15">Detayları Gör</span>
            <span className="ti-arrow-right"></span>
          </a>
          {item.url && (
            <a
              href={item.url}
              target="_blank"
              rel="noopener noreferrer"
              className="d-flex align-items-center p-color"
            >
              <span className="text mr-15">Siteyi Ziyaret Et</span>
              <span className="ti-arrow-top-right"></span>
            </a>
          )}
        </div>
      </div>
    </div>
  );
}

export function PortfolioSidebar({ items, currentId }) {
  const categories = {};
  items.forEach((p) => {
    if (p.category) categories[p.category] = (categories[p.category] || 0) + 1;
  });

  const recent = items.filter((p) => p.id !== currentId).slice(0, 3);

  return (
    <div className="sidebar">
      <div className="widget">
        <h6 className="title-widget">Ara</h6>
        <div className="search-box">
          <input type="text" name="search-portfolio" placeholder="Projede ara..." />
          <span className="icon pe-7s-search"></span>
        </div>
      </div>
      <div className="widget catogry">
        <h6 className="title-widget">Kategoriler</h6>
        <ul className="rest">
          {Object.entries(categories).map(([name, count]) => (
            <li key={name}>
              <span>
                <a href="/portfolio">{name}</a>
              </span>
              <span className="ml-auto">{count}</span>
            </li>
          ))}
        </ul>
      </div>
      <div className="widget last-post-thum">
        <h6 className="title-widget">Son Projeler</h6>
        {recent.map((item) => (
          <div key={item.id} className="item d-flex align-items-center">
            <div>
              <div className="img">
                <a href={`/portfolio-details/${item.id}`}>
                  <img src={item.coverImg || '/assets/imgs/works/1/1.jpg'} alt="" />
                </a>
              </div>
            </div>
            <div className="cont">
              <span className="tag">
                <a href="/portfolio">{item.category}</a>
              </span>
              <h6>
                <a href={`/portfolio-details/${item.id}`}>
                  {item.title} {item.titleHighlight}
                </a>
              </h6>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
